export const COUNTRY_CURRENCY = {
  US: 'USD',
  CA: 'CAD'
};
